const mbrSplideEl = document.querySelector('.member-slider');
if (mbrSplideEl?.dataset.id) {
  let mbrSplide = new Splide(`.splide-${mbrSplideEl.dataset.id}`);
  mbrSplide.on('ready', function () {
    if (mbrSplide.root.classList.contains('splide--hidden')) mbrSplide.root.classList.remove('splide--hidden');
  });
  mbrSplide.on('mounted dragged move', function () {
    const bar = mbrSplide.root.querySelector('.progress-bar');
    const end = mbrSplide.Components.Controller.getEnd() + 1;
    const rate = Math.min((mbrSplide.index + 1) / end, 1);
    if (bar) bar.style.width = `${String(100 * rate)}%`;
  });
  mbrSplide.mount();

  if (window.Shopify.designMode && mbrSplideEl?.dataset.id) {
    document.addEventListener('shopify:section:load', (event) => {
      mbrSplide = new Splide(`.splide-${mbrSplideEl.dataset.id}`);
      mbrSplide.on('ready', function () {
        if (mbrSplide.root.classList.contains('splide--hidden')) mbrSplide.root.classList.remove('splide--hidden');
      });
      mbrSplide.on('mounted dragged move', function () {
        const bar = mbrSplide.root.querySelector('.progress-bar');
        const end = mbrSplide.Components.Controller.getEnd() + 1;
        const rate = Math.min((mbrSplide.index + 1) / end, 1);
        if (bar) bar.style.width = `${String(100 * rate)}%`;
      });
      mbrSplide.mount();
    });
  }
}
